import { FC, useEffect, useState } from 'react';
import './PtaScheduledMeeting.scss';
import images from '../../assets/images';
import { useLazyQuery } from '@apollo/client';
import { useAppSelector } from '../../redux/app/hooks';
import ToasterWithMessage from '../toaster';
import { FETCH_POLICY_NO_CACHE, JITSI, PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from '../../utils/constants';
import { getFormattedDateInfo } from '../../utils/helper';
import PtaMeetingDetailView from '../PtaMeetingDetailView/PtaMeetingDetailView';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCurrentSessionDetail, setIsStartingMeeting } from '../../redux/slices/dashboardSlice';
import { setSplashvisible } from '../../redux/slices/authSlice';
import { useGlobalState } from '../../MeetContext/MeetContext';
import { PtaMeetType } from '../../pages/PtaMeetings/PtaMeetings';
import { GET_PTA_MEETING_BY_ID } from '../../pages/AdminPta/api/PtaQuery';
import { getChimeParticipants } from '../../Chime/helpers/get-participants';
import { setParticipantJoin, setParticipantLeft } from '../../redux/slices/JitsiMeetSlice';

interface propsType{
    upcomingSessionList: PtaMeetType[];
    singleSessionDetail: PtaMeetType | undefined;
    setSingleSessionDetail: (val: PtaMeetType | undefined) => void;
    fetchUpcomingSessions?: () => void;
    setIsClickedSessionDetail: (val: boolean) => void;
    setIsShowBackArrow: (val: boolean) => void;
    handleClickMoreIcon: (event: React.MouseEvent<HTMLElement>, MeetingDetails: PtaMeetType) => void;
    fetchRecordedSessions: () => void;
    refetch: boolean;
    setRefetch: (val: boolean) => void;
}

const PtaScheduledMeeting:FC<propsType> = ({ setIsClickedSessionDetail, fetchUpcomingSessions, upcomingSessionList, setSingleSessionDetail, singleSessionDetail, setIsShowBackArrow, handleClickMoreIcon, fetchRecordedSessions, setRefetch, refetch }) => {
  const { MoreIcon, WhiteMoreIcon, NoMeeting } = images;
  const {localStream, setIsMeetingEndByHost} = useGlobalState();
  const {error} = ToasterWithMessage();
  const [sessionEnded, setSessionEnded] = useState<boolean>(false);
  const role = useAppSelector((state) => state.auth.role); 
  const meetService = useAppSelector((state) => state.auth.meetService);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const isParticipantJoin = useAppSelector((state) => state.JitsiMeetSlice.participantJoin)
  const isParticipantLeft = useAppSelector((state)  => state.JitsiMeetSlice.participantLeft)

  const [getSinglePtaMeeting] = useLazyQuery(GET_PTA_MEETING_BY_ID, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      dispatch(setParticipantLeft({ participantLeft: false  }));
      dispatch(setParticipantJoin({ participantJoin: false  }));
      setIsShowBackArrow(true);
      // fetchRecordedSessions();
      if (localStorage.getItem('isGuest') === 'true' && role === PTA_ROLE) {
        navigate('/pta-signup', {
          state: {
            category: location?.state?.category,
            meeting: data?.getMeetingById
          }
        });
        dispatch(setSplashvisible());
      }
      else {
        const response = data?.getMeetingById || {};
        const meetId = response?.mCode;

        console.log("meet id, meet service", meetId, meetService)
        if (meetId && meetService !== JITSI) {
          getChimeParticipants(meetId)
            .then((participantsResponse) => {
              response.mParticipantCount = participantsResponse?.Attendees ? participantsResponse.Attendees.length : 0;
            })
            .catch(() => {
              response.mParticipantCount = 0;
            })
            .finally(() => {
              console.log("[Log] Participants count:", response.mParticipantCount);
              setSingleSessionDetail(response);
            });
        } else {
          setSingleSessionDetail(response);
        }
        setSessionEnded(false);
      }
    },
    onError: (err) => {  
      dispatch(setIsStartingMeeting({ isStartingMeeting: false }));    
      if(err?.message === "Meeting has ended"){
         setSessionEnded(true);
         setIsShowBackArrow(role === PTA_ROLE ? false : true);
         error(err?.message)
          setTimeout(() => {
            const navigationPath = role === SCHOOL_ADMIN ? "/admin-pta/meetings" : role === TEACHER_ROLE ? "/teacher-pta" : "/pta-meetings"
            navigate(navigationPath, {
              state: {
                category: location?.state?.category
              }
            })
          }, 2000)
      }else {
        error(err?.message)
      }
    }
  });

  //set the particular data when click card
  const onClickSingleSession = (cardItem:PtaMeetType) => {
    setIsClickedSessionDetail(true);
    getSinglePtaMeeting({
      variables:{
        mId: cardItem?.mId
      }
    })
  };

  const fetchSessionDetails = () => {
    if (singleSessionDetail) {
      getSinglePtaMeeting({
        variables:{
          mId: singleSessionDetail?.mId
        }
      });
    }
  };

  useEffect(()=>{
    if(isParticipantJoin){
      console.log("participant Joined [debug]")
      fetchSessionDetails()
    }
  },[isParticipantJoin])

  useEffect(()=>{
    if(isParticipantLeft){
            console.log("participant Joined [debug] left")
      fetchSessionDetails()
    }
  },[isParticipantLeft])

  useEffect(() => {
    dispatch(setCurrentSessionDetail({startDate: null, endDate: null}));
    setIsMeetingEndByHost(false);
      //To set stop camera and microphone when initial render.
      if(localStream?.getVideoTracks()[0]){
            localStream.getVideoTracks()[0].enabled = false;
        }
        localStream?.getVideoTracks()[0]?.stop();
        if(localStream?.getAudioTracks()[0]){
            localStream.getAudioTracks()[0].enabled = false;
        }
        localStream?.getAudioTracks()[0]?.stop();
  }, [])
  
   return (
    <div className='upcomingSessionMainContainer'>
      {(singleSessionDetail?.mId) ? (
        <PtaMeetingDetailView 
          fetchSessionDetails={fetchSessionDetails} 
          singleSessionDetail={singleSessionDetail} 
          sessionEnded={sessionEnded}
        />
         ) : (
        <div className='upcomingSessionListContainer'>
            {(upcomingSessionList.length > 0) ? (
              <div className='cardContainer'>
                {
                  upcomingSessionList?.map((cardItem: PtaMeetType,index: number) => {
                    const {dayMessage,formattedDate,dayOfWeek} = getFormattedDateInfo(cardItem?.mStartTime);                              
                    return (
                      <div className={(cardItem?.isActive) ? "activeSessionForTeacher" : 'upcomingSessionCard'} onClick={() => onClickSingleSession(cardItem)} key={`${index}-${cardItem?.mId}`}>
                            <div className='titleContainer'>
                              <div className={cardItem?.isActive ? 'activeDotContainer': 'forTeacherStyle'} style={{backgroundColor: ((cardItem?.isActive) && (role === STUDENT_ROLE)) ? '#0B74BB' : '', marginLeft: ((cardItem?.isActive) && (role === STUDENT_ROLE)) ? '25px' : '17px'}}>
                                {cardItem?.isActive ? <span className='activeDot'></span> : ''}
                                <div className={(cardItem?.isActive) ? 'activeTitleStyle' : 'titleStyle'} style={{color: (cardItem?.isActive ? 'white' : 'black')}}>{dayMessage}</div>
                              </div>
                              {(role === SCHOOL_ADMIN) && ( 
                                <div className='moreIconContainer' onClick={(e) => handleClickMoreIcon(e, cardItem)}>
                                  <img src={cardItem?.isActive ? WhiteMoreIcon : MoreIcon} alt='more' className='moreIconStyle'/>
                                </div>
                              )}
                            </div>
                            <div className='dayContainer'>
                                <div className={(cardItem?.isActive) ? 'activeDayStyle': 'dayStyle'}>{dayOfWeek}</div>
                                <div className={(cardItem?.isActive) ? 'activeMonthDateStyle' : 'monthDateStyle'}>{formattedDate}</div>
                            </div>
                      </div>
                    )
                  }
                )
                }
              </div>
              ) : (
              <div className='noMeeting'>
                <img src={NoMeeting} className='noMeetingGif' alt='noMeetingGif'/>
                <div className='noMeetingTitle'>No Meeting Available</div>
              </div>
            )}
        </div>          
      )}
    </div>
  )
}

export default PtaScheduledMeeting;
